const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// This navigates to a hash and then removes it from the URL, to prevent weird behavior on mobile.
const navigateToHash = async (hash, waitMs = 500) => {
    await sleep(waitMs);
    document.getElementById(hash).scrollIntoView({ behavior: 'smooth' });
}

export default navigateToHash;